import React, { useState } from "react";
import { DataFileModel } from "../api/vehicleFileAPI";
import {
  Button,
  ButtonGroup,
  Col,
  Container,
  ListGroup,
  ListGroupItem,
  Row,
} from "react-bootstrap";
import DataFileItem from "./DataFileItem";
import { DashSquare, PlusSquare } from "react-bootstrap-icons";
import { DataFileEntry, sortDataFileEntries } from "../common/fileUtils";

interface DataFileListProps {
  files: DataFileEntry[];
  isDisabled: boolean;
  onView: (fullPath: string) => void;
  onDownload: (fullPath: string) => void;
  onDelete: (fullPath: string) => void;
  onUpdate: (file: DataFileModel) => void;
}

function DataFileList({
  files,
  isDisabled,
  onView,
  onDownload,
  onDelete,
  onUpdate,
}: DataFileListProps) {
  const [expandedDirectories, setExpandedDirectories] = useState<string[]>([]);

  const directoryClick = (name: string) => {
    const expanded = expandedDirectories.find((x) => x === name);

    if (expanded) {
      setExpandedDirectories(expandedDirectories.filter((x) => x !== expanded));
    } else {
      setExpandedDirectories([...expandedDirectories, ...[name]]);
    }
  };

  return (
    <div>
      {files.length === 0 && "No files..."}

      {files.length > 0 && (
        <ListGroup>
          {sortDataFileEntries(files).map((f) => (
            <ListGroupItem key={f.name}>
              {f.entries.length === 0 && f.file && (
                <DataFileItem
                  label={f.name}
                  file={f.file}
                  isDisabled={isDisabled}
                  onView={() => f.file && onView(f.fullPath)}
                  onUpdate={() => f.file && onUpdate(f.file)}
                  onDownload={() => f.file && onDownload(f.fullPath)}
                  onDelete={() => f.file && onDelete(f.fullPath)}
                />
              )}
              {f.entries.length > 0 && (
                <>
                  <Container
                    role="button"
                    onClick={() => directoryClick(f.name)}
                    style={{ marginBottom: "8px", maxWidth: "none" }}
                  >
                    <Row>
                      <Col>
                        {expandedDirectories.findIndex((x) => x === f.name) >=
                        0 ? (
                          <DashSquare
                            size={12}
                            style={{ marginLeft: "-15px", marginRight: "4px" }}
                          />
                        ) : (
                          <PlusSquare
                            size={12}
                            style={{ marginLeft: "-15px", marginRight: "4px" }}
                          />
                        )}
                        {f.name}
                      </Col>
                      <Col md="auto">
                        <ButtonGroup size="sm">
                          <Button
                            type="button"
                            size="sm"
                            onClick={(e) => {
                              onDownload(f.fullPath);
                              // we don't want the directory to expand
                              e.stopPropagation();
                              e.nativeEvent.stopImmediatePropagation();
                            }}
                          >
                            Download
                          </Button>
                          <Button
                            type="button"
                            size="sm"
                            variant="danger"
                            disabled={isDisabled}
                            onClick={(e) => {
                              if (
                                window.confirm(
                                  "Are you sure you want to delete this directory?",
                                )
                              )
                                onDelete(f.fullPath);
                              // we don't want the directory to expand
                              e.stopPropagation();
                              e.nativeEvent.stopImmediatePropagation();
                            }}
                          >
                            Delete
                          </Button>
                        </ButtonGroup>
                      </Col>
                    </Row>
                  </Container>

                  {expandedDirectories.findIndex((x) => x === f.name) >= 0 && (
                    <DataFileList
                      files={f.entries}
                      isDisabled={isDisabled}
                      onView={onView}
                      onUpdate={onUpdate}
                      onDownload={onDownload}
                      onDelete={onDelete}
                    />
                  )}
                </>
              )}
            </ListGroupItem>
          ))}
        </ListGroup>
      )}
    </div>
  );
}

export default DataFileList;
